export enum TipologiaRapporto {
  'CLIENTE',
  'CONTATTO QUALIFICATO',
  'CESSATA ATTIVITA',
  'PROSPECT',
}
